// extracted by mini-css-extract-plugin
module.exports = {"title":"title___26fZA","featuredAuthor":"featuredAuthor___1aOU8"};